(function () {
  'use strict';

  angular
    .module('enumModule', []);
}());
